import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs'; // Cleaned up path reference to standard rxjs package imports

@Injectable({
  providedIn: 'root'
})
export class AgentBackgroundService {
  constructor(private http: HttpClient) { }
  getActivatedServices(): any[] {
    const services = sessionStorage.getItem('activatedServices');
    return services ? JSON.parse(services) : [];
  }

  isServiceActive(serviceName: string): boolean {
    const services = this.getActivatedServices();
    const normalizeValue = (value: string) =>
      value?.toLowerCase().replace(/\s+/g, '').trim();

    const service = services.find(
      serviceItem =>
        normalizeValue(serviceItem.serviceName) ===
        normalizeValue(serviceName)
    );
    //const service = services.find(s => s.serviceName === serviceName);
    return service ? true : false;
  }

  getAgentData(): any {
    const agentData = sessionStorage.getItem('agentData');
    return agentData ? JSON.parse(agentData) : null;
  }

  clearSession(): void {
    sessionStorage.removeItem('agentData');
    sessionStorage.removeItem('activatedServices');
  }
  getAgentById(id: string): Observable<any> {
    return this.http.get<any>(API_ENDPOINTS.AGENT_DATA.GET_AGENT_BY_ID(id));
  }

}